module.exports = __webpack_public_path__ + "img/zu.855c9dc1.svg";